import { TbReportMoney } from 'react-icons/tb'

import { DictionaryStatusTag } from '@/Containers/TransportationSection/Components'
import { Hint } from '@/Ship/Components/Hint'

import { LOST_APPLICATION_STATUS } from '../Contracts/IClientLossesReport'
import { LogisticiansInvolvementTable } from '../Components/LogisticiansInvolvementTable'
import { ReportFrame } from '../Components/ReportFrame'
import { logisticiansInvolvementReportStore } from '../Stores/ReportStore'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/** «Звіт по залученню логістів» (`SPEC-027` §2.2, §4.3). */
const LogisticiansInvolvementPage = () => (
    <ReportFrame
        reportKey="Report.LogisticiansInvolvement"
        store={logisticiansInvolvementReportStore}
        hint={
            <Hint id="report.involvement.table">
                Кожна колонка має свою дату: створення заявки, запиту, тендера чи пропозиції; підтвердження — дата
                призначення відповідальним; вивантаження — дата розвантаження; програш — дата переведення в{' '}
                <DictionaryStatusTag resource={LOST_APPLICATION_STATUS.resource} code={LOST_APPLICATION_STATUS.code} />.
            </Hint>
        }
        isEmpty={(report) => report.rows.length === 0}
    >
        {(report) => <LogisticiansInvolvementTable report={report} />}
    </ReportFrame>
)

export default LogisticiansInvolvementPage

export const pageConfig: IPageConfig = {
    key: 'Report.LogisticiansInvolvement',
    route: '/report/logisticians-involvement',
    title: 'Звіт по залученню логістів',
    icon: <TbReportMoney />,
}
